import { services } from "../../../../constants/services";
import { getAll } from "../../../../utils/api";

export const GetEnvironmetService = async () => {
  const response: any = await getAll<any[]>(`${services["environment-variables"]}/api-services`);
  return response?.data;
};